"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function returnFalse() {
    return false;
}
exports.default = returnFalse;
